require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-project-مصنع-تيتان-للاسمنت.json") })
        }
      }, "path---ar-eg-project-مصنع-تيتان-للاسمنت");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-project-مصنع-تيتان-للاسمنت!./.cache/json/ar-eg-project-مصنع-تيتان-للاسمنت.json
// module id = 440
// module chunks = 231608221292675